module.exports = __webpack_public_path__ + "img/01d7ffd37e6f92486751b7101293yyd2.08019913.png";